/**
 * Potential (likelihood to move) tiers — same score bands as LikelihoodToMoveTableCell.
 */
export const POTENTIAL_TIER_FILTER_OPTIONS = [
  { id: "excellent", label: "Excellent" },
  { id: "great", label: "Great" },
  { id: "good", label: "Good" },
  { id: "fair", label: "Fair" },
  { id: "slim", label: "Slim" },
]

export function isPotentialTierId(value) {
  return (
    typeof value === "string" &&
    POTENTIAL_TIER_FILTER_OPTIONS.some((o) => o.id === value)
  )
}
